module.exports = __webpack_public_path__ + "static/media/Frost.9c231f2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Frost.jpg
// module id = 1023
// module chunks = 0